import type { PillTone } from '@/components/ui';
import { BLOCK_TRADE_STATUS, BlockTradeStatus } from '@/types/blockTrade';

/**
 * Pill tone per block-trade status, shared by the deal book and the detail page.
 * The label is the backend's `status_display`; only the tone is decided here.
 * Available is the live, actionable state; Expired is neutral — not a failure.
 */
const BLOCK_TRADE_STATUS_TONE: Partial<Record<BlockTradeStatus, PillTone>> = {
  [BLOCK_TRADE_STATUS.AVAILABLE]: 'positive',
  [BLOCK_TRADE_STATUS.EXPIRED]: 'neutral',
};

export const blockTradeStatusTone = (status: BlockTradeStatus): PillTone =>
  BLOCK_TRADE_STATUS_TONE[status] ?? 'neutral';
